import ReactDOM from 'react-dom';
import './index.scss';
import reportWebVitals from './reportWebVitals';
import 'semantic-ui-css/semantic.min.css';
import { Provider as ReduxProvider } from 'react-redux';
import App from './App';
import { ConnectedRouter } from 'connected-react-router';
import configureStore, { history } from './redux/configureStore';

const store = configureStore();

ReactDOM.render(
  <ReduxProvider store={store}>
    <ConnectedRouter history={history}>
      <App />
    </ConnectedRouter>
  </ReduxProvider>,
  document.getElementById('root')
);

reportWebVitals();
